<ng-template #content let-modal>
    <div class="modal-header">
        <h4>{{modalHeader}}</h4>
    </div>

    <div class="modal-body">
        You have an onboarding step to complete
    </div>

    <div class="modal-footer">
        <a href="/organizations/{{orgId}}/onboard">
            <button class="btn btn-primary">
                Go to Onboarding
            </button>
        </a>
        <button (click)="completeStep()" class="btn btn-outline-secondary">
            Mark Complete
        </button>
        <button (click)="modal.dismiss('Cross click')" class="btn btn-outline-secondary">
            Handle Later
        </button>
    </div>
</ng-template>